import { Menu, MenuContent, MenuTrigger } from '@optiaxiom/react';

import type { SpecializedAgent } from '@frontend/types/specialized-agent';

const INFERENCE_TYPES = [
  {
    value: 'rudimentary',
    label: 'Quick',
    description: 'Fast, basic responses for simple questions or tasks.',
  },
  {
    value: 'simple',
    label: 'Standard',
    description: 'Reliable answers for most everyday needs.',
  },
  {
    value: 'simple_with_thinking',
    label: 'Balanced',
    description: 'Like Standard, but with extra reasoning.',
  },
  {
    value: 'complex',
    label: 'Complex',
    description: 'Advanced reasoning and detail for complex tasks.',
  },
  {
    value: 'complex_with_thinking',
    label: 'Pro',
    description: 'Maximum reasoning depth for the toughest or most nuanced challenges.',
  },
  { value: 'code', label: 'Code', description: 'Writes, explains, and debugs code.' },
];

type InferenceTypeSelectorProps = {
  value: SpecializedAgent['inference_type'];
  onChange: (value: SpecializedAgent['inference_type']) => void;
  disabled?: boolean;
};

export function InferenceTypeSelector({
  value,
  onChange,
  disabled = false,
}: InferenceTypeSelectorProps) {
  return (
    <Menu
      options={INFERENCE_TYPES.map(option => ({
        label: option.label,
        description: option.description,
        execute: () => onChange(option.value as SpecializedAgent['inference_type']),
        selected: option.value === value,
      }))}
    >
      <MenuTrigger w="224" disabled={disabled}>
        {INFERENCE_TYPES.find(opt => opt.value === value)?.label || 'Standard'}
      </MenuTrigger>
      <MenuContent />
    </Menu>
  );
}
